// Queries and mutations for the Profile page (excluding 2FA, members, audit).

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";
import type { SessionRow } from "@/types/profile";

export function useSessions() {
  return useQuery({
    queryKey: ["auth", "sessions"],
    queryFn: () => api<SessionRow[]>("/auth/sessions"),
  });
}

export function useRevokeSession() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (sessionId: string) =>
      api(`/auth/sessions/${sessionId}/revoke`, { method: "POST" }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["auth", "sessions"] });
    },
  });
}

export function useRevokeAllSessions() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api("/auth/sessions/revoke-all", { method: "POST" }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["auth", "sessions"] });
    },
  });
}

export interface ChangePasswordInput {
  current_password: string;
  new_password: string;
}

export function useChangePassword() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: ChangePasswordInput) =>
      api("/auth/change-password", { method: "POST", body: input }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["auth", "sessions"] });
    },
  });
}
